import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface Locale {
    lang: string;
    data: any;
}

@Injectable({
    providedIn: 'root'
})
export class I18nLoaderService {

    constructor(private _translateService: TranslateService) {
    }
    useLanguage(lang): void {
        this._translateService.use(lang);
    }
    loadTranslations(...args: Locale[]): void {
        const locales = [...args];

        locales.forEach((locale) => {
            this._translateService.addLangs([locale.lang]);
            this._translateService.setTranslation(locale.lang, locale.data, true);
        });
    }
}
